var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEuro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.931 14.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M567.156,1221.567a.5.5,0,0,0-.707.006,6.485,6.485,0,0,1-10.776-2.478H561.6a.5.5,0,0,0,0-1h-6.168a6.519,6.519,0,0,1-.095-1.011c0-.108.009-.215.013-.323h6.25a.5.5,0,0,0,0-1h-6.138a6.436,6.436,0,0,1,1.735-3.281,6.525,6.525,0,0,1,4.614-1.941h.006a6.48,6.48,0,0,1,4.616,1.948.5.5,0,0,0,.717-.7,7.484,7.484,0,0,0-5.334-2.251H561.8a7.536,7.536,0,0,0-5.326,2.24,7.437,7.437,0,0,0-2.035,3.982h-2.569a.5.5,0,0,0,0,1h2.471c0,.111-.014.221-.013.333a7.561,7.561,0,0,0,.083,1h-2.541a.5.5,0,0,0,0,1h2.753a7.478,7.478,0,0,0,7.191,5.42h.069a7.436,7.436,0,0,0,5.274-2.241A.5.5,0,0,0,567.156,1221.567Z",
    transform: "translate(-551.375 -1209.539)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.5bcb3c15.svg";
export { ForwardRef as ReactComponent };